import { useState } from "react";
import { UploadCloud } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { api } from "../../axios/api";
import { notify } from "../../utils/toastAlert";
import { setCachedLicenseStatus, clearCachedLicenseStatus } from "../../utils/licenseCache";

const LicenseExpired = () => {
  const navigate = useNavigate();
  const [licenseFile, setLicenseFile] = useState("");
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const handleFile = async (event) => {
    const file = event.target.files?.[0];
    if (!file) return;
    setLicenseFile(await file.text());
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    setErrorMessage("");

    try {
      await api.post("/licensas/importar", { license_file: licenseFile });
      const status = await api.get("/licensas/status");
      setCachedLicenseStatus(status.data || {});
      await notify("Licença activada com sucesso.", "success");
      navigate("/dashboard/main", { replace: true });
      window.location.reload();
    } catch (error) {
      const message = error.response?.data?.error || error.message || "Não foi possível activar a licença.";
      clearCachedLicenseStatus();
      setErrorMessage(message);
      await notify(message, "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="license-expired-page">
      <section className="license-expired-panel">
        <div className="license-expired-icon"><UploadCloud size={30} /></div>
        <h1>Licença expirada ou ausente</h1>
        <p>Carregue o arquivo .lic emitido no painel da API para desbloquear esta empresa neste módulo.</p>
        {errorMessage && <div className="license-error">{errorMessage}</div>}
        <form onSubmit={handleSubmit}>
          <input type="file" accept=".lic,.txt" onChange={handleFile} />
          <textarea value={licenseFile} onChange={(event) => setLicenseFile(event.target.value)} placeholder="Cole aqui o conteúdo do arquivo de licença" required />
          <button type="submit" disabled={loading || !licenseFile.trim()}>{loading ? "A validar..." : "Activar licença"}</button>
        </form>
      </section>
    </main>
  );
};

export default LicenseExpired;
